import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './CarouselItem.scss';

export default class CarouselItem extends PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    innerRef: PropTypes.func,
    bare: PropTypes.bool,
  };

  render() {
    const { children, loading, innerRef } = this.props;
    const itemClassName = cx(
      'sb-header__carousel__item',
      {
        itemLoading: loading
      },
    );
    return (
      <div className={itemClassName} ref={innerRef}>
        <div className='sb-header__carousel__item-internal'>
          {children}
        </div>
      </div>
    );
  }
}
